angular.module('impactx.ruleset').controller('RuleSetCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'ToastService',
    'TranslationService',
    'BackService',
    'ToolbarService',
    'ConfirmationService',
    RuleSetCtrl
]);

function RuleSetCtrl($scope, dataGen, $routeParams, ToastService, TranslationService, BackService, ToolbarService, ConfirmationService) {
    var self = this;

    dataGen.getData($scope, {id: $routeParams.id}, "/ruleset/view").then(function () {
        $scope.trns.required = TranslationService.get('required');
        defineButtons();
    });

    self.save = function () {
        return dataGen.postAsForm($scope, {formData: $scope.data}, "/ruleset/save").then(function () {
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
            BackService.back();
        });
    };

    self.deleteDialog = function (event) {
        ConfirmationService.showConfirmationDialog(self.delete, event,
            TranslationService.get('confirmDelete'), TranslationService.get('delete'), TranslationService.get('abort'));
    };

    self.delete = function () {
        return dataGen.postAsForm($scope, {id: $scope.data.id}, "/ruleset/delete").then(function () {
            ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
            BackService.back();
        })
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: self.save,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.delete,
                action: self.deleteDialog,
                type: 'dialogaction',
                condition: canDelete
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.readOnly;
    }

    function canDelete() {
        return $scope.data.id > 0 && !$scope.data.isGlobalSet;

    }
}